import { findParentNode } from '@atlaskit/editor-prosemirror/utils';
import { fg } from '@atlaskit/platform-feature-flags';

/**
 * Finds all top level nodes affected by the transaction
 * Uses from/to positions in transaction's steps to work out which nodes will
 * be changed by the transaction
 */
export var findChangedNodesFromTransaction = function findChangedNodesFromTransaction(tr) {
  var nodes = [];
  var steps = tr.steps || [];
  steps.forEach(function (step) {
    step.getMap().forEach(function (oldStart, oldEnd, newStart, newEnd) {
      tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), function (node) {
        var nodeToCheck = node;
        if (fg('cc_complexit_fe_improve_node_validation')) {
          var schema = tr.selection.$from.doc.type.schema;
          var parentNode = findParentNode(function (node) {
            return node.type !== schema.nodes.paragraph;
          })(tr.selection);
          nodeToCheck = parentNode ? parentNode.node : node;
        }
        if (!nodes.find(function (n) {
          return n === nodeToCheck;
        })) {
          nodes.push(nodeToCheck);
        }
        return false;
      });
    });
  });
  return nodes;
};